<template>
    <div>
        <el-tag :key="tag.id" v-for="tag in tagList" closable :disable-transitions="false" @close="handleClose(tag)"
            style="margin: 5px">
            {{ tag.fileType }}
        </el-tag>
        <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="small"
            @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
        </el-input>
        <el-button v-else class="button-new-tag" size="small" @click="showInput">+ New Tag</el-button>
    </div>
</template>
<script>
import { findAllType, delFileType, addFileType } from "@/api/file";
export default {
    components: {},
    data() {
        return {
            tagList: [],
            inputVisible: false,
            inputValue: "",
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            findAllType().then((res) => {
                if (res.data.code == 200) {
                    this.tagList = res.data.data;
                }
            });
        },
        handleClose(data) {
            //console.log("data", data);
            delFileType({ id: data.id }).then((res) => {
                //console.log("res", res);
                if (res.data.code == 200) {
                    this.$message({
                        message: res.data.data,
                        type: "success",
                    });
                    this.init();
                    this.$emit('AddTag')
                } else {
                    this.$message({
                        message: res.data.data,
                        type: "error",
                    });
                }
            });
        },
        showInput() {
            this.inputVisible = true;
            this.$nextTick((_) => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },

        handleInputConfirm() {
            let inputValue = this.inputValue;
            if (inputValue) {
                // this.dynamicTags.push(inputValue);
                addFileType({ fileType: inputValue }).then((res) => {
                    //console.log("res", res);
                    if (res.data.data == "添加成功") {
                        this.$message({
                            message: res.data.data,
                            type: "success",
                        });
                        this.init();
                    } else {
                        this.$message({
                            message: res.data.msg,
                            type: "error",
                        });
                    }
                });
            }
            this.inputVisible = false;
            this.inputValue = "";
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/File/comp/TagList.vue